import { Button } from '~/components/ui/button';
import FeedbackBlock from '../FeedbackBlock';

import { SignUpForm } from '../HeroSection';
import { ArrowRight, Download } from 'lucide-react';
import { Link } from '@remix-run/react';

import WordLogo from '~/assets/word.svg';
import OutlookLogo from '~/assets/outlook.svg';
import TeamsLogo from '~/assets/teams.svg';
import ChromeLogo from '~/assets/chrome.svg';
import GmailLogo from '~/assets/gmail.svg';
import TelegramLogo from '~/assets/telegram.svg';
import OneNote from '~/assets/onenote.svg';
import ExcelLogo from '~/assets/excel.svg';
import SheetsLogo from '~/assets/sheets.svg';
import DocsLogo from '~/assets/docs.svg';
import SlidesLogo from '~/assets/slides.svg';
import PowerPointLogo from '~/assets/powerpoint.svg';

export const BrowseIntegrationsButton = ({ label = 'Browse Integrations' }) => {
    return (
        <Button
            asChild
            className='flex-col items-center text-left h-26  w-full mx-0 inline-flex justify-center px-8 py-3.5 mt-0 font-bold transition-all  border-none font-pj text-lg rounded-xl md:mx-auto md:w-full bg-blue-600  text-white focus:outline-none hover:bg-black hover:bg-gradient-to-r hover:from-black hover:to-black'>
            <Link to='/integrations'>
                <div className='mt-4 flex items-center'>
                    <span>{label}</span>
                    <ArrowRight className='ml-1 h-10 w-10' />
                </div>
                <div className='flex -space-x-2'>
                    <img
                        src={WordLogo}
                        alt='Word'
                        className='bg-white w-8 h-8 rounded-full border-2 border-white'
                    />
                    <img
                        src={OutlookLogo}
                        alt='Outlook'
                        className='bg-white w-8 h-8 rounded-full border-2 border-white'
                    />
                    <img
                        src={ExcelLogo}
                        alt='Excel'
                        className='bg-white w-8 h-8 rounded-full border-2 border-white'
                    />
                    <img
                        src={PowerPointLogo}
                        alt='Excel'
                        className='bg-white w-8 h-8 rounded-full border-2 border-white'
                    />
                    <img
                        src={OneNote}
                        alt='Excel'
                        className='bg-white w-8 h-8 rounded-full border-2 border-white'
                    />
                </div>
            </Link>
        </Button>
    );
};

const Testimonials = () => {
    return (
        <section className='py-10 bg-gray-100 sm:py-16 lg:py-24'>
            <div className='max-w-5xl px-4 mx-auto sm:px-6 lg:px-8'>
                <div className='grid grid-cols-1 md:grid-cols-2 md:gap-x-16 lg:gap-x-24 gap-y-10'>
                    <div>
                        <FeedbackBlock
                            authorName='Lisa Sharpe'
                            authorRole='Content Manager at Starbucks'
                            title='Love using it'
                            text={`I love using AI Perfect Assistant for
                            Office365! It makes writing blogs so easy with
                            its prompt templates, language preferences,
                            writing style and writing tone options. It
                            always gives me impressive results with
                            brilliant formatting!`}
                        />
                    </div>

                    <div>
                        <div className='overflow-hidden bg-white'>
                            <div className='p-8 lg:px-12 lg:py-10'>
                                <h3 className='text-2xl font-semibold text-black'>
                                    Join 2,362 happy users
                                </h3>
                                <p className='my-4 text-base text-gray-600'>
                                    Unlock Office 365's Full Potential. Automate
                                    Mundane Business Tasks with AI Perfect
                                    Assistant.
                                </p>
                                <BrowseIntegrationsButton />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
